import { CATEGORY_LABEL, type ContentCategory } from "@/types/content";

const STYLES: Record<ContentCategory, string> = {
  drama: "bg-primary-100 text-primary-800",
  characters: "bg-accent-100 text-accent-900",
  news: "bg-secondary-200 text-secondary-900",
};

export default function CategoryBadge({
  category,
  className = "",
}: {
  category: ContentCategory;
  className?: string;
}) {
  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium whitespace-nowrap ${STYLES[category]} ${className}`}
    >
      {CATEGORY_LABEL[category]}
    </span>
  );
}